import { render, staticRenderFns } from "./blog-aero-vs-gb.vue?vue&type=template&id=3afd0429"
import script from "./blog-aero-vs-gb.vue?vue&type=script&lang=js"
export * from "./blog-aero-vs-gb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports